import { SearchOperationBuilder, SearchParam } from 'wherecomposer/dist/SearchParam';
import { ConditionCreator } from 'wherecomposer/dist/ConditionCreator';
import { getCountry } from '../graphql/country';
import { Auth, API, graphqlOperation, Amplify } from 'aws-amplify';

let countryAppSyncUrl = process.env.REACT_APP_COUNTRY_APPSYNC_URL;
let countryApiKey = process.env.REACT_APP_COUNTRY_API_KEY;


const getCountryData = async () => {
    let languageGuid = localStorage.getItem('languageGuid');
    let languageCode = localStorage.getItem("languageCode");

    try {
        let lstobjSearchParam = [];
        let objSearchParam = new SearchParam();
        objSearchParam.searchParamCreate("LanguageGuid", "Guid", languageGuid, SearchOperationBuilder.create(true, false, false));
        lstobjSearchParam.push(objSearchParam);
        let objCreator = new ConditionCreator();
        let objWhere = objCreator.getSearchCondition(lstobjSearchParam);

        const countryConfig = {
            API: {
                'graphql_endpoint': countryAppSyncUrl,
                graphql_headers: async () => {
                    const currentSession = await Auth.currentSession();
                    return {
                        'Authorization': currentSession.getIdToken().getJwtToken(),
                        'language': languageCode,
                        'x-api-key': countryApiKey
                    };
                }
            }
        }

        Amplify.configure(countryConfig);

        return await API.graphql(graphqlOperation(getCountry, { OperationList: objWhere.toJsonString() }));
    } catch (error) {
        console.log('getCountryData error', error);
    }


}


export {
    getCountryData,
}